import { FunctionComponent, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { removeToast, Toast } from "./store/toastSlice";

const ICONS: Record<Toast["type"], string> = {
  coins:       "₽",
  xp:          "⬡",
  achievement: "◆",
  levelup:     "▲",
  info:        "●",
  error:       "✕",
};

const AUTO_DISMISS_MS = 3500;

const ToastItem: FunctionComponent<{ toast: Toast }> = ({ toast }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const timer = setTimeout(() => dispatch(removeToast(toast.id)), AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [toast.id, dispatch]);

  return (
    <div
      className={`Toast Toast-${toast.type}`}
      onClick={() => dispatch(removeToast(toast.id))}
    >
      <div className="Toast-icon">{ICONS[toast.type]}</div>
      <div className="Toast-body">
        <div className="Toast-message">{toast.message}</div>
        {toast.subtext && <div className="Toast-subtext">{toast.subtext}</div>}
      </div>
      {toast.amount !== undefined && (
        <div className="Toast-amount">
          {toast.amount > 0 ? "+" : ""}{toast.amount}
        </div>
      )}
    </div>
  );
};

const ToastContainer: FunctionComponent = () => {
  const toasts = useAppSelector((state) => state.toast.toasts);
  if (toasts.length === 0) return null;

  return (
    <div className="Toast-container">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} />
      ))}
    </div>
  );
};

export default ToastContainer;
